import PanelConfig from '../../components/panel_config/PanelConfig.vue'

export default {
    components: {
        PanelConfig
    }
}